document.addEventListener( 'DOMContentLoaded', () => {
	const navBlocks = document.querySelectorAll( '.k8-scroll-to-block' );

	if ( ! navBlocks.length ) {
		return;
	}

	const HEADER_OFFSET = 80;

	navBlocks.forEach( ( nav ) => {
		nav.addEventListener( 'click', ( event ) => {
			const link = event.target.closest( '[data-scroll-target]' );

			if ( ! link || ! nav.contains( link ) ) {
				return;
			}

			const targetSlug = link.getAttribute( 'data-scroll-target' );
			const targetEl = document.querySelector(
				`[data-scroll-target="${ targetSlug }"].alternating-content-row`
			);

			if ( ! targetEl ) {
				return;
			}

			event.preventDefault();

			const targetPosition =
				targetEl.getBoundingClientRect().top +
				window.pageYOffset -
				HEADER_OFFSET;

			window.scrollTo( {
				top: targetPosition,
				behavior: 'smooth',
			} );
		} );
	} );
} );